var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { UtilService } from '@app/utility/util.service';
import { ApiService } from '@app/utility/api.service';
var ForgotPasswordComponent = /** @class */ (function () {
    function ForgotPasswordComponent(util, apiService) {
        this.util = util;
        this.apiService = apiService;
        this.submitted = false;
        this.username = "";
        this.oldPass = "";
        this.newPass = "";
        this.confirmPass = "";
        this.tokenId = "";
        this.userId = "";
    }
    ForgotPasswordComponent.prototype.ngOnInit = function () {
        var cookieData = JSON.parse(localStorage.getItem("dpa_cc"));
        this.username = cookieData["username"];
        this.userId = cookieData["userId"];
    };
    ForgotPasswordComponent.prototype.changePassword = function () {
        return __awaiter(this, void 0, void 0, function () {
            var guidReq, guidRes, req, res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.submitted = true;
                        if (!(this.username.trim().length > 0 && this.oldPass.length > 0 && this.newPass.length > 0 && this.newPass == this.confirmPass
                            && this.passwordValidation())) return [3 /*break*/, 10];
                        this.util.ShowWaiting(true);
                        guidReq = {
                            username: this.username
                        };
                        return [4 /*yield*/, this.apiService.postCustom("Crm", "InsertChangeCallCenterPassToken", guidReq)];
                    case 1:
                        guidRes = _a.sent();
                        if (!(this.util.isSuccessResponse(guidRes) && guidRes.token_id != "")) return [3 /*break*/, 8];
                        this.tokenId = guidRes.token_id;
                        guidReq = {
                            dpa_customwebuserid: this.userId,
                            guid: guidRes.token_id
                        };
                        return [4 /*yield*/, this.apiService.post("crmservice", "updateCallcenterGuid", guidReq)];
                    case 2:
                        guidRes = _a.sent();
                        if (!(this.util.isSuccessResponse(guidRes) && guidRes.RESMSG == "SUCCESS")) return [3 /*break*/, 6];
                        if (!(this.oldPass == this.newPass)) return [3 /*break*/, 3];
                        this.util.ErrorDialog("เปลี่ยน Password ไม่สำเร็จ password ต้องไม่เท่ากับ password เดิม");
                        return [3 /*break*/, 5];
                    case 3:
                        req = {
                            "mode": 1,
                            "oldPassword": this.oldPass,
                            "newPassword": this.newPass,
                            guid: this.tokenId
                        };
                        return [4 /*yield*/, this.apiService.put("crmservice", "callcenterChangepassword/" + this.username, req)];
                    case 4:
                        res = _a.sent();
                        if (this.util.isSuccessResponse(res) && res.RESMSG == "SUCCESS") {
                            this.clear();
                            this.util.SuccessDialog("เปลี่ยน Password สำเร็จ");
                        }
                        else {
                            this.util.ErrorDialog("เปลี่ยน Password ไม่สำเร็จ");
                        }
                        _a.label = 5;
                    case 5: return [3 /*break*/, 7];
                    case 6:
                        this.util.ErrorDialog("เปลี่ยน Password ไม่สำเร็จ");
                        _a.label = 7;
                    case 7: return [3 /*break*/, 9];
                    case 8:
                        this.util.ErrorDialog("เปลี่ยน Password ไม่สำเร็จ");
                        _a.label = 9;
                    case 9:
                        this.util.ShowWaiting(false);
                        _a.label = 10;
                    case 10: return [2 /*return*/];
                }
            });
        });
    };
    ForgotPasswordComponent.prototype.clear = function () {
        this.submitted = false;
        this.oldPass = "";
        this.newPass = "";
        this.confirmPass = "";
    };
    ForgotPasswordComponent.prototype.close = function () {
        window.close();
    };
    ForgotPasswordComponent.prototype.passwordValidation = function () {
        return /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,16}$/.test(this.newPass);
    };
    return ForgotPasswordComponent;
}());
export { ForgotPasswordComponent };



// WEBPACK FOOTER //
// ./src/app/account/forgot-password/forgot-password.component.ts.pre-build-optimizer.js